import React from 'react';
import { render } from '@testing-library/react';
import userEvent from '@testing-library/user-event';

import { Icon } from '../Icon';
import { Form } from '../Form';
import { Input } from '../Input';

const FormInputIcon = () => {
	const handleClick = () => console.warn('icon clicked');
	const handleSubmit = () => console.warn('form submitted');

	return (
		<Form onSubmit={handleSubmit}>
			<Input
				className="i1"
				placeholder="Placeholder"
				icon={<Icon name="help" onClick={handleClick} />}
			/>
		</Form>
	);
};

describe('test Input with an Icon.onClick inside', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	jest.spyOn(global.console, 'warn');
	console.warn = jest.fn(); // Prevent actual console.warn from showing up in command line

	const getElements = () => {
		const { container } = render(<FormInputIcon />);

		return [
			container.querySelector('.i1 input') as HTMLInputElement,
			container.querySelector('.i1 .a-Icon') as HTMLInputElement,
		];
	};
	const user = userEvent.setup();

	it('should be focused on Input click', async () => {
		const [input, icon] = getElements();

		expect(input).not.toHaveFocus();
		expect(icon).not.toHaveFocus();
		await user.click(input);
		expect(input).toHaveFocus();
		expect(icon).not.toHaveFocus();
		console.warn('warn to count first call of console.warn');
		expect(console.warn).toHaveBeenCalledTimes(1);
	});

	it('should not call handleClick on enter keypress', async () => {
		const [input, icon] = getElements();

		await user.click(input);
		await user.keyboard('hello');
		expect(input).toHaveFocus();
		expect(icon).not.toHaveFocus();
		await user.keyboard('{enter}');
		expect(console.warn).toHaveBeenCalledTimes(2);
		expect(console.warn).toBeCalledWith('form submitted');
	});

	it('should call handleClick when click on Icon', async () => {
		const [input, icon] = getElements();

		await user.click(icon);
		expect(input).not.toHaveFocus();
		expect(icon).toHaveFocus();
		expect(console.warn).toHaveBeenCalledTimes(3);
		expect(console.warn).toBeCalledWith('icon clicked');
	});
});

describe('Input', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Input
				className="i1"
				placeholder="Placeholder"
				icon={<Icon name="help" />}
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
